import { render, staticRenderFns } from "./u-chip-flat-pill.vue?vue&type=template&id=091b9b1b&scoped=true&"
import script from "./u-chip-flat-pill.vue?vue&type=script&lang=js&"
export * from "./u-chip-flat-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091b9b1b",
  null
  
)

export default component.exports